<div class="job-console-container">

  <!-- Toolbar: refresh button + tab pills (refresh first, tabs after) -->
  <div class="job-console-toolbar">
    <button type="button"
            class="gt-refresh-btn"
            [class.spinning]="loading"
            title="Refresh data"
            (click)="refresh()"
            (keydown.enter)="refresh()"
            (keydown.space)="refresh(); $event.preventDefault()">
      <i class="fa fa-refresh"></i>
    </button>

    <ul class="tab tab-pills">
      <li (click)="onTabChange(0)"
          (mouseenter)="jobsTabHover = true"
          (mouseleave)="jobsTabHover = false">
        <a [ngClass]="{
             'activeTab': activeTab === 0,
             'inactiveTab': activeTab !== 0 && jobsTabHover
           }">Job Grids</a>
      </li>
      <li (click)="onTabChange(1)"
          (mouseenter)="logsTabHover = true"
          (mouseleave)="logsTabHover = false">
        <a [ngClass]="{
             'activeTab': activeTab === 1,
             'inactiveTab': activeTab !== 1 && logsTabHover
           }">Job Log History</a>
      </li>
    </ul>
  </div>
  <hr class="tab-separator" />

  <!-- Tab 1: Job Grids -->
  @if (activeTab === 0) {
<div class="grid-host">
    <div #jobsGrid="adminGrid"
         adminGrid
         [gridConfig]="jobsGridConfig"
         (gridCallback)="onGridCallback($event)"
         (gridDataLoaded)="onGridDataLoaded($event)"
         (loadingStateChange)="onJobsLoadingChange($event)"
         class="gizmo-grid"
         tabindex="2"></div>

    @if (jobsLoading) {
<div class="grid-loader-overlay">
      <i class="fa fa-spinner fa-pulse"></i>
      <span>Loading jobs…</span>
    </div>
}
  </div>
}

  <!-- Tab 2: Job Log History -->
  @if (activeTab === 1) {
<div class="grid-host">
    <div #logHistoryGrid="adminGrid"
         adminGrid
         [gridConfig]="logHistoryGridConfig"
         (gridCallback)="onGridCallback($event)"
         (gridDataLoaded)="onGridDataLoaded($event)"
         (loadingStateChange)="onLogsLoadingChange($event)"
         class="gizmo-grid"
         tabindex="3"></div>

    @if (logsLoading) {
<div class="grid-loader-overlay">
      <i class="fa fa-spinner fa-pulse"></i>
      <span>Loading job log history…</span>
    </div>
}
  </div>
}

</div>
